import type { CartV2 } from '@redteclab/api/clients/bully'
import type { AxiosResponse } from 'axios'

import BackendAPIService from 'shared/services/api/BackendAPIService'
import type { ServiceParameters } from 'shared/services/api/commonTypes'

export class CartServiceBase extends BackendAPIService {
  constructor(props: ServiceParameters) {
    super(props)
    this.apiVersion = props.apiVersion ?? 'v4'
  }

  public getCartUrl = (): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}`

  public putCartUrl = (): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}`

  public createCartUrl = (): string =>
    `/${this.language}/cart/${this.apiVersion}/${this.tenantPath}/entry`

  public deleteCartUrl = (offerId: string, pType: string): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}/entry/${offerId}?prescriptionType=${pType}`

  public getMiniCartUrl = (): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}/minicart`

  public redPointsUrl = (): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}/redpoints`

  public voucherUrl = (): string =>
    `/cacheable/${this.language}/cart/${this.apiVersion}/${this.tenantPath}/voucher`

  async fetchCart<T = CartV2>(
    purgeMessages?: boolean,
    nowZipCode?: string,
    includeMaxDosage?: boolean
  ): Promise<AxiosResponse<T>> {
    const shouldPurge: boolean = purgeMessages || false
    const shouldIncludeMaxDosage: boolean = includeMaxDosage || true

    const response: AxiosResponse<T> = await this.get(this.getCartUrl(), {
      params: {
        purgeMessages: `${shouldPurge}`,
        nowZipCode,
        includeMaxDosage: `${shouldIncludeMaxDosage}`,
      },
    })

    this.logger.debug(`${this.constructor.name} fetch cart!`, 'dataFetching')
    return response
  }
}
